import { Modal, Spin, Table, Tabs } from "antd";
import { useState } from "react";
import useBusinessUsersListHook from "./useBusinessUsersListHook";
import { isEmpty } from "lodash";
import { Col, Form, FormGroup, Input, Row } from "reactstrap";

const filterStates = {
    'all': {name:'All',count:-1},
    'active': {name:'Active',count:0},
    'activation':  {name:'Pending Approval',count:0},
    'free': {name:'Free',count:0},
    'trialing': {name:'Free Trial',count:0},
    'pending': {name:'Pending Cancel',count:0},
    'canceled': {name:'Cancelled',count:0},
};

const BusinessUsersList = () => {
    const [activeFilter, setFilter] = useState('all');
    const { columns, companyProfileList, isLoading, companyProfileUnlisted, tabKey, setTabKey, unListedRowData, setUnListedRowData } = useBusinessUsersListHook();
    let listedUsers = companyProfileList;
    const nonListedUsers = companyProfileUnlisted;
    console.log('nonListedUsers: ', nonListedUsers);
    // Reset filter counts
    Object.keys(filterStates).map((filterSlug) => {
        filterStates[filterSlug].count = 0;
        if( "all" === filterSlug ){
            filterStates[filterSlug].count = -1;
        }
    });
    
    const filterUsers = (user) => {
        // Determine current plan
        const status = user?.pricingPlan?.subscriptionStatus ?? null;
        const cancelAt = user?.pricingPlan?.cancelAt ?? null;
        const isVerified = user?.isVerified ?? false;
        // Check if cancelled date is past
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Set time to midnight to only compare dates
        const todayTime = today.getTime();
        const isCancelled = ("canceled" === status) || ( (null !== cancelAt) && (cancelAt * 1000 <= todayTime) );
        
        const plan = (null !== cancelAt || "canceled" === status)
            ? isCancelled
                ? "canceled"
                : "pending"
            : (null !== status)
                ? status
                : "free";
        // Add to counter
        if( typeof filterStates[plan] !== "undefined" ){
            filterStates[plan].count++;
        }
        // Handle Pending Activation status
        if( !isVerified ){
            filterStates['activation'].count++;
        }
        if( 'all' === activeFilter || plan === activeFilter || ('activation' === activeFilter && !isVerified) ){
            return true;
        }
        return false;
    };
    
    // Filter listedUsers and nonListedUsers by activeFilter
    listedUsers = listedUsers.filter( filterUsers );
    //nonListedUsers = nonListedUsers.filter( filterUsers );
    
    return (
        <div className="content mb-0">
            <h2 className="page-main-title">Business Users</h2>
            {isLoading ? (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                    }}
                >
                    <Spin size="large" />
                </div>
            ) : (
                <Tabs defaultActiveKey={tabKey} onChange={setTabKey} type="card">
                    <Tabs.TabPane tab={"Registered Users (" + listedUsers.length + ")"} key="1">
                        <div className="mb-2">
                            {Object.keys(filterStates).map((filterSlug, i) => (
                                <>
                                    {filterStates[filterSlug].count !== 0 ? (
                                        <>
                                            <a
                                                className={"cursor-pointer"}
                                                style={{color:(filterSlug===activeFilter)?"#023A28":"#1677ff"}}
                                                onClick={elm => {setFilter(filterSlug);}}
                                            >
                                                {filterStates[filterSlug].name}
                                                {filterStates[filterSlug].count > 0 ? "("+filterStates[filterSlug].count+")" : null}
                                            </a>
                                            {(i+1 < Object.keys(filterStates).length) ? " | " : null}
                                        </>
                                    ) : null}
                                </>
                            ))}
                        </div>
                        <Table
                            rowClassName={() => "custom-table-row"}
                            columns={columns}
                            dataSource={listedUsers}
                            rowKey="_id"
                            pagination={false}
                            scroll={
                                listedUsers.length > 0 ? { y: 670, x: 1300 } : undefined
                            }
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={"Non-Registered Users (" + nonListedUsers.length + ")"} key="2">
                        <Table
                            rowClassName={() => "custom-table-row"}
                            columns={columns}
                            dataSource={nonListedUsers}
                            rowKey="_id"
                            pagination={false}
                            scroll={
                                nonListedUsers.length > 0 ? { y: 670, x: 1300 } : undefined
                            }
                        />
                    </Tabs.TabPane>
                </Tabs>
            )}
            <Modal
                className="common-admin-popup"
                open={!isEmpty(unListedRowData)}
                onCancel={() => {
                    setUnListedRowData({});
                }}
                centered
                destroyOnClose
                // onOk={handleSubmitData}
                width={1200}
                footer={null}
            >
                <Form>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <label className="card-sub-title">Company</label>
                                <Input
                                    className="input-value"
                                    value={unListedRowData?.companyName}
                                    placeholder="Company"
                                    type="text"
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="card-sub-title">Email address</label>
                                <Input
                                    className="input-value"
                                    placeholder="Email"
                                    type="email"
                                    value={unListedRowData?.contact?.email}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="card-sub-title">Website</label>
                                <Input
                                    className="input-value"
                                    value={unListedRowData?.contact?.website}
                                    placeholder="Website"
                                    type="text"
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <label className="card-sub-title">Phone</label>
                                <Input
                                    className="input-value"
                                    placeholder="Phone"
                                    value={unListedRowData?.contact?.phone}
                                    disabled
                                    type="text"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="card-sub-title">Testing Time</label>
                                <Input
                                    className="input-value"
                                    placeholder="Testing Time"
                                    value={unListedRowData?.testingTime}
                                    disabled
                                    type="text"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="card-sub-title">Vaccinated: </label>
                                {/* <Input
                                                    placeholder="Vaccinated"
                                                    type="checkbox"
                                                    checked={unListedRowData?.isVaccinated}
                                                    className="ml-3"
                                                /> */}
                                <span className="static-value">
                                    {unListedRowData?.isVaccinated ? "Yes" : "No"}
                                </span>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <label className="card-sub-title">Services</label>
                                {unListedRowData?.services?.map((srvs, idx) => {
                                    return (
                                        <p className="text-capitalize mb-0">
                                            {idx + 1}. {srvs.name}
                                        </p>
                                    );
                                })}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="card-sub-title">Softwares</label>
                                {unListedRowData?.software?.map((sftwr, idx) => {
                                    return (
                                        <p className="text-capitalize mb-0">
                                            {idx + 1}. {sftwr.name}
                                        </p>
                                    );
                                })}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="card-sub-title">Equipments</label>
                                {unListedRowData?.equipment?.map((eqpmnt, idx) => {
                                    return (
                                        <p className="text-capitalize mb-0">
                                            {idx + 1}. {eqpmnt.name}
                                        </p>
                                    );
                                })}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="card-sub-title">
                                    Additional Requirements
                                </label>
                                {unListedRowData?.additionalRequirements?.map(
                                    (adReq, idx) => {
                                        return (
                                            <p className="text-capitalize mb-0">
                                                {idx + 1}. {adReq}
                                            </p>
                                        );
                                    }
                                )}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="card-sub-title">
                                    Primary Language
                                </label>
                                <p className="text-capitalize mb-0">
                                    {unListedRowData && unListedRowData?.language?.[0]?.language}
                                </p>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="card-sub-title">
                                    Secondary Language
                                </label>
                                {unListedRowData?.language
                                    ?.splice(1)
                                    ?.map((sec, idx) => {
                                        return (
                                            <p className="text-capitalize mb-0">
                                                {idx + 1}. {sec?.language}
                                            </p>
                                        );
                                    })}
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>
    );
};

export default BusinessUsersList;
